(() => {
  const maxOne = ['É', 'È', 'Q', 'X', 'Y', 'Z', '#', '&', '@', '+', '?', 'Ô', '!', ' '];
  const maxTwo = ['B', 'C', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'P', 'S', 'T', 'U', 'V', 'W', '.', '/', '♥', '3', '4', '5', '6', '7', '8', '9', '"'];
  const maxThree = ['A', 'E', 'N', 'O', 'R', '0'];
  const maxFour = ['I', '1', '2'];

  function getMaxForChar(char) {
    if (maxOne.includes(char)) return 1;
    if (maxTwo.includes(char)) return 2;
    if (maxThree.includes(char)) return 3;
    if (maxFour.includes(char)) return 4;
    return 0;
  }

  function getOrCreateErrorEl(input) {
    const field = input.closest('.embossing-block__field') || input.parentElement;
    if (!field) return null;

    let errorEl = field.querySelector('.embossing-block__error');
    if (errorEl) return errorEl;

    errorEl = document.createElement('div');
    errorEl.className = 'embossing-block__error';
    errorEl.style.display = 'none';
    errorEl.style.marginTop = '0.35rem';
    errorEl.style.fontSize = '0.8rem';
    errorEl.style.color = '#b30000';
    field.appendChild(errorEl);

    return errorEl;
  }

  function showError(input, message) {
    const errorEl = getOrCreateErrorEl(input);
    if (!errorEl) return;

    if (errorEl._hideTimer) {
      clearTimeout(errorEl._hideTimer);
    }

    errorEl.textContent = message;
    errorEl.style.display = 'block';

    errorEl._hideTimer = setTimeout(() => {
      errorEl.style.display = 'none';
    }, 3000);
  }

  function sanitizeInput(input) {
    const maxLengthAttr = Number.parseInt(input.getAttribute('maxlength'), 10) || 10;
    const value = (input.value || '').toUpperCase();

    let cleanedValue = '';
    const counts = {};

    for (const char of value) {
      const maxAllowed = getMaxForChar(char);
      counts[char] = (counts[char] || 0) + 1;

      if (maxAllowed === 0) {
        showError(input, "Character '" + char + "' is not allowed.");
      } else if (counts[char] > maxAllowed) {
        showError(input, "Maximum count for '" + char + "' reached.");
      } else if (cleanedValue.length >= maxLengthAttr) {
        showError(input, 'Maximum of ' + maxLengthAttr + ' characters reached.');
        break;
      } else {
        cleanedValue += char;
      }
    }

    if (input.value !== cleanedValue) {
      const cursor = Math.min(cleanedValue.length, input.selectionStart || cleanedValue.length);
      input.value = cleanedValue;
      input.setSelectionRange(cursor, cursor);
    }
  }

  function onKeydown(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-embossing-text]')) return;

    const maxLengthAttr = Number.parseInt(input.getAttribute('maxlength'), 10) || 10;
    const currentVal = input.value || '';

    const isFunctionalKey =
      event.key === 'Backspace' ||
      event.key === 'Delete' ||
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown' ||
      event.key === 'Tab' ||
      event.key === 'Home' ||
      event.key === 'End' ||
      event.key === 'Enter';

    const hasShortcutModifier = event.ctrlKey || event.metaKey || event.altKey;

    if (currentVal.length >= maxLengthAttr && !isFunctionalKey && !hasShortcutModifier) {
      showError(input, 'Maximum of ' + maxLengthAttr + ' characters reached.');
    }
  }

  function onInput(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-embossing-text]')) return;
    sanitizeInput(input);
  }

  function onSymbolClick(event) {
    const button = event.target.closest('[data-embossing-symbol]');
    if (!button) return;

    const root = button.closest('.embossing-block');
    const input = root ? root.querySelector('[data-embossing-text]') : null;
    if (!(input instanceof HTMLInputElement)) return;

    requestAnimationFrame(() => sanitizeInput(input));
  }

  document.addEventListener('keydown', onKeydown);
  document.addEventListener('input', onInput);
  document.addEventListener('click', onSymbolClick);
})();
